import React from "react";
import { Plus, Pencil, X, Search } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { iconBtnClass } from "@/components/Brand";

/** Folder tabs with inline rename/delete, plus the search and sort controls. */
export const ProjectFilters = ({
  folders, folder, onFolder, onNewFolder, onRenameFolder, onDeleteFolder,
  query, onQuery, sort, onSort, showToolbar,
}) => {
  const { t } = useI18n();

  return (
    <>
      <div className="flex flex-wrap items-center gap-2 mb-6" data-testid="folder-bar">
        {[{ id: "all", name: t("all_galleries") }, { id: "none", name: t("unfiled") }].map((f) => (
          <button key={f.id} data-testid={`folder-tab-${f.id}`} onClick={() => onFolder(f.id)}
            className={`px-4 py-2 min-h-[40px] text-[10px] tracking-[0.14em] uppercase border transition-colors ${
              folder === f.id ? "border-[#D4AF37] text-[#D4AF37]" : "border-[#2A2A2A] text-[#A8A8A8] hover:border-[#D4AF37]"
            }`}>{f.name}</button>
        ))}
        {folders.map((f) => (
          <span key={f.folder_id}
            className={`inline-flex items-center gap-2 border pl-3 pr-2 py-1.5 text-[10px] tracking-[0.14em] uppercase ${
              folder === f.folder_id ? "border-[#D4AF37] text-[#D4AF37]" : "border-[#2A2A2A] text-[#A8A8A8]"
            }`}>
            <button data-testid={`folder-tab-${f.folder_id}`} onClick={() => onFolder(f.folder_id)}
              className="min-h-[40px] flex items-center">{f.name}</button>
            <button data-testid={`folder-rename-${f.folder_id}`} onClick={() => onRenameFolder(f)}
              aria-label={t("rename_folder")}
              className={`${iconBtnClass} text-[#5A5A5A] hover:text-[#D4AF37]`}><Pencil size={13} /></button>
            <button data-testid={`folder-delete-${f.folder_id}`} onClick={() => onDeleteFolder(f)}
              aria-label={t("delete_folder")}
              className={`${iconBtnClass} text-[#5A5A5A] hover:text-[#8B0000]`}><X size={13} /></button>
          </span>
        ))}
        <button data-testid="new-folder-btn" onClick={onNewFolder}
          className="inline-flex items-center gap-1 px-4 min-h-[40px] text-[10px] tracking-[0.14em] uppercase text-[#D4AF37] hover:underline">
          <Plus size={12} /> {t("new_folder")}
        </button>
      </div>

      {showToolbar && (
        <div className="flex flex-wrap items-center gap-4 mb-8" data-testid="project-toolbar">
          <div className="relative flex-1 min-w-[240px]">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5A5A5A]" />
            <input data-testid="project-search-input" value={query} onChange={(e) => onQuery(e.target.value)}
              placeholder={t("search_projects")}
              className="w-full bg-[#0B0B0B] border border-[#2A2A2A] pl-9 pr-3 py-2.5 text-sm focus:border-[#D4AF37] focus:outline-none" />
          </div>
          <select data-testid="project-sort-select" value={sort} onChange={(e) => onSort(e.target.value)}
            className="select-dark text-base sm:text-[10px] sm:font-mono-accent min-h-[44px] sm:min-h-0">
            <option value="newest">{t("sort_newest")}</option>
            <option value="alpha">{t("sort_alpha")}</option>
          </select>
        </div>
      )}
    </>
  );
};
